export const COMPANY_KEY = "taf_company";

export const COMPANY_META = {
  taf: {
    id: "taf",
    name: "TAF Villas Kos",
    short: "TAF",
    tagline: "Φιλοξενία & Διαχείριση Βιλών",
    expenseCategories: ["Συντήρηση", "Παροχές Πελατών", "Προμήθειες Βίλας", "Φαγητό & Ποτό", "Μεταφορές", "Άλλο"],
  },
};

export const getCompany = () => {
  const c = localStorage.getItem(COMPANY_KEY);
  return COMPANY_META[c] ? c : "taf";
};

export const setCompany = (id) => {
  localStorage.setItem(COMPANY_KEY, COMPANY_META[id] ? id : "taf");
  applyCompanyTheme();
};

export const companyMeta = (id) => COMPANY_META[id || getCompany()] || COMPANY_META.taf;

export const applyCompanyTheme = () => {
  document.documentElement.setAttribute("data-company", getCompany());
};
